const base_URI = () => {
  // IP = 72.61.135.15
  // PORT = 3001
  let REACT_APP_URI = `${process.env.REACT_APP_SERVER_URL}/api`;
  return REACT_APP_URI;
};

const base_URI_API = () => {
  // IP = 72.61.135.15
  // PORT = 3001
  let REACT_APP_URI_API = `${base_URI()}/api`;
  return REACT_APP_URI_API;
};

const analyze_URI = () => {
  // let REACT_APP_URI_IMAGE_ANALYZE = "http://72.61.135.15:3011/api/analyze";
  let REACT_APP_URI_IMAGE_ANALYZE = `${base_URI_API()}/analyze`;
  return REACT_APP_URI_IMAGE_ANALYZE;
};

const Oee_URI = () => {
  // let REACT_APP_URI_OEE = "http://72.61.135.15:3011/api/sdaca";
  let REACT_APP_URI_OEE = `${base_URI_API()}/sdaca`;
  return REACT_APP_URI_OEE;
};
const maquina_URI = () => {
  // let REACT_APP_URI_MAQ = "http://72.61.135.15:3011/api/maquina";
  let REACT_APP_URI_MAQ = `${base_URI_API()}/maquina`;
  return REACT_APP_URI_MAQ;
};
const chart_Oee_URI = () => {
  // let REACT_APP_URI_CHART_OEE = "http://72.61.135.15:3011/api/oeeChart";
  let REACT_APP_URI_CHART_OEE = `${base_URI_API()}/oeeChart`;
  return REACT_APP_URI_CHART_OEE;
};
const last_Events_URI = () => {
  // let REACT_APP_last_Events_URI = "http://72.61.135.15:3011/api/eventos";
  let REACT_APP_last_Events_URI = `${base_URI_API()}/eventos`;
  return REACT_APP_last_Events_URI;
};

const last_Values_URI = () => {
  // let REACT_APP_last_Values_URI = "http://72.61.135.15:3011/api/lastValues";
  let REACT_APP_last_Values_URI = `${base_URI_API()}/lastValues`;
  return REACT_APP_last_Values_URI;
};
//const handleSidebar = (draw) => {
// let RECT_DRAW = true;
// if (draw === true) {
//   return (RECT_DRAW = true);
// } else {
//  return (RECT_DRAW = false);
// }
//};

module.exports = {
  base_URI,
  analyze_URI,
  Oee_URI,
  maquina_URI,
  chart_Oee_URI,
  last_Events_URI,
  last_Values_URI,
  //handleSidebar,
};
